import { Evidence, EVIDENCE_TYPE } from './evidence';

export class Quote {
    id: string;
    text: string;

    constructor(
        private _evidence: Evidence,
        params: { id?: string; text: string },
    ) {
        this.id = params.id || this._evidence.coords.uniqueId();
        this.text = params.text;
    }

    delete() {
        this._evidence.deleteQuote(this);
    }

    update({ text, tag }: { text?: string; tag: EVIDENCE_TYPE }) {
        if (text !== undefined) {
            if (!this._evidence.coords.utils$.htmlTextContent(text)) return this.delete();
            this.text = text;
        }
        if (tag !== undefined) {
            this._evidence.changeQuoteType(this, tag);
        }
    }

    toJSONready() {
        return {
            id: this.id,
            text: this.text,
        };
    }
}
